import { checkForErrors } from './Validation';

const extractArrayPhasesOrFail = (data) => {
  let extractedData = []
  for (let field of data) {
    let extractedField = {}
    if (checkForErrors(field) === false && extractedData !== false) {
      Object.keys(field).forEach(key => {
        extractedField[key] = field[key].value;
      })
      extractedData.push(extractedField)
    } else extractedData = false;
  }
  return extractedData;
}

export const extractPhasesOrFail = (data) => {
  let extractedData = {}
  Object.keys(data).forEach(key => {
    if (checkForErrors(data[key]) === false && extractedData !== false) {
      Object.keys(data[key]).forEach(nestedKey => {
        if (data[key][nestedKey].breed === 'array') {
          extractedData[nestedKey] = extractArrayPhasesOrFail(data[key][nestedKey].values);
          if (extractedData[nestedKey] === false) return false;
        }
        else extractedData[nestedKey] = data[key][nestedKey].value;
      })
    } else {
      extractedData = false;
    }
  })
  return extractedData;
}



/** WEBPACK FOOTER **
 ** ./src/helpers/ValueBuilder.js
 **/